import { render, staticRenderFns } from "./SharedTab.vue?vue&type=template&id=d0e85208&scoped=true&"
import script from "./SharedTab.vue?vue&type=script&lang=js&"
export * from "./SharedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e85208",
  null
  
)

export default component.exports